export default __webpack_public_path__ + "static/media/intellectual-property.f634733a.jpg";